import React from 'react'
import PropTypes from 'prop-types'

import ErrorMessage from './ErrorMessage'
import ApptTypesTable from './ApptTypesTable'
import NewPatientApptTypes from './NewPatientApptTypes'

import styles from './styles.css'

export default function ApptTypesContainer({
  appointmentTypes,
  patchAppointmentType,
  hasPatientPortal,
}) {
  const newAppointmentTypes = appointmentTypes.filter(
    type => type.visibility === 'new',
  )

  return (
    <div>
      {appointmentTypes.length ? (
        <div className={styles.appointmentTypes}>
          <div className={styles.appointmentTypesNewCol}>
            <NewPatientApptTypes
              newAppointmentTypes={newAppointmentTypes}
              patchAppointmentType={patchAppointmentType}
            />
          </div>
          <div className={styles.appointmentTypesTableCol}>
            <ApptTypesTable
              appointmentTypes={appointmentTypes}
              patchAppointmentType={patchAppointmentType}
              hasPatientPortal={hasPatientPortal}
            />
          </div>
        </div>
      ) : (
        <ErrorMessage />
      )}
    </div>
  )
}

ApptTypesContainer.propTypes = {
  appointmentTypes: PropTypes.arrayOf(
    PropTypes.shape({
      code: PropTypes.string.isRequired,
      description: PropTypes.string.isRequired,
      visibility: PropTypes.string,
    }),
  ),
  patchAppointmentType: PropTypes.func.isRequired,
  hasPatientPortal: PropTypes.bool.isRequired,
}



// WEBPACK FOOTER //
// ./src/components/OnlineScheduling/AppointmentTypes/ApptTypesContainer.js